/**
 * UI-only provider metadata. Live OAuth is Agent-driven — never use secrets here.
 * Blocked providers come from candor_host_matrix.json / REACT_APP_SSO_BLOCKED_PROVIDERS.
 */
import { blockedSsoProviders } from '../../../config/environments';

/** UI metadata only. Live buttons come from the Agent /providers list. */
export const CLOUD_AUTH_PROVIDERS = [
  { id: 'google', name: 'Google', color: '#4285F4' },
  { id: 'microsoft', name: 'Microsoft', color: '#00A4EF' },
  { id: 'github', name: 'GitHub', color: '#24292e' },
  { id: 'gitlab', name: 'GitLab', color: '#FC6D26' },
  { id: 'yahoo', name: 'Yahoo', color: '#6001D2' },
];

/** Frozen snapshot for UI filters (env/matrix at module load). */
export const SSO_BLOCKED_PROVIDERS = Object.freeze([...blockedSsoProviders()]);

export const getCloudProvider = (providerId) => {
  return CLOUD_AUTH_PROVIDERS.find((p) => p.id === String(providerId || '').toLowerCase());
};

export { getSsoWebRedirectUri as getRedirectUri } from './ssoAgentClient';
export { ProviderMark, humanizeSsoError } from './providerIcons';
